import { getCurrentStep } from '../store/flow/selectors';
import { getIsJapan } from '../utils/getIsJapan';
import { Step } from 'signup-constants/Step';
export const shouldAddOptionalPhoneNumber = state => {
  return getIsJapan(state) && getCurrentStep(state) === Step.CompanyName;
};